import { Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class WindowEventsService {
  get onResize(): Observable<Window> {
    return this.resizeSubject.asObservable();
  }

  private resizeSubject: Subject<Window>;

  constructor() {
    this.resizeSubject = new Subject();

    window.addEventListener('resize', this.onResizeUpdate.bind(this));
  }

  private onResizeUpdate(event: UIEvent) {
    this.resizeSubject.next(<Window>event.target);
  }
}
